export const ORDER_MODIFICATION_SUMMARY_COLUMNS = [
  {
    label: "Description",
    field: "description",
  },
  {
    label: "Current Order",
    field: "currentOrder",
  },
  {
    label: "Proposed Order",
    field: "proposedOrder",
  },
];

export const MODIFIED_ORDER_SUMMARY_COLUMNS = [
  {
    label: "Description",
    field: "description",
  },
  {
    label: "Proposed Order",
    field: "proposedOrder",
  },
];

export const CUSTOMER_SALES_SOURCE_ID = 3;

export const LEARN_VERTICAL_ID = 1;

export const ALREADY_MODIFIED_ERROR_CODE = {
  PROPOSAL_ALREADY_ACCEPTED: "PROPOSAL_ALREADY_ACCEPTED",
  PROPOSAL_ALREADY_REJECTED: "PROPOSAL_ALREADY_REJECTED",
  ORDER_PROPOSAL_NOT_FOUND: "ORDER_PROPOSAL_NOT_FOUND",
};

export const ORDER_PROPOSAL_STATUS = {
  CREATED: 1,
  ACCEPTED: 2,
  REJECTED_BY_CUSTOMER: 3,
  REJECTED_BY_CUSTOMER_SUPPORT: 4,
  DISCARDED: 5,
};
